import { useState, useEffect } from "react";
import { message, Modal } from "antd";
import { DropzoneArea } from "material-ui-dropzone";
import { useHistory } from 'react-router-dom'

import Layout from "../Layout/Layout";
import Header from "../Components/Header";
import Map from "../Components/Map";
import EmailImage from "../Assets/email.png";
import { url, header } from "../Constent/Constant";
import GetQuoteForm from "../Components/GetQuoteForm";

function Storage() {
  const [StorageData, setStorageData] = useState("");
  const [Email, setEmail] = useState("");
  const [HeadingUpdate, setHeadingUpdate] = useState("");
  const [TextModalVisible, setTextModalVisible] = useState(false);
  const [ImageUpdate, setImageUpdate] = useState(null);
  const [ImageModal, setImageModal] = useState(false);
  const [UpdateId, setUpdateId] = useState("");
  const history = useHistory()

  const LoggedIn = localStorage.getItem('MS-Login')
  if(LoggedIn !== 'true'){
    history.push('/')
  }

  useEffect(() => {
    UpdateData()
  }, []);

  const UpdateData = () => {
    fetch(`${url}/page/viewpagedata`, {
      method: "POST",
      body: JSON.stringify({
        name: "Storage",
      }),
      headers: header,
    })
      .then((res) => res.json())
      .then((data) => {
        console.log(data);
        setStorageData(data.doc);
      });
  }

  const OnEmailSubmit = () => {
    if (Email === "") {
      message.error("Fill Field Correctly");
    } else {
      fetch(`${url}/page/addsubscriber`, {
        method: "POST",
        body: JSON.stringify({
          data: {
            email: Email,
          },
        }),
        headers: header,
      })
        .then((res) => res.json())
        .then((data) => {
          console.log(data);
          if (data.message === "Success") {
            message.success("Thank You");
            setEmail("");
          }
        });
    }
  };

  const UpdateText = (DataObject) => {
    console.log(DataObject);
    if (DataObject !== "") {
      fetch(`${url}/page/updatedata`, {
        method: "POST",
        body: JSON.stringify({
          id: DataObject.id,
          content: DataObject.text,
        }),
        headers: header,
      })
        .then((res) => res.json())
        .then((data) => {
          console.log(data);
          if (data.message === "Success") {
            UpdateData();
          }
        });
    }
  };

  const UpdateImage = (DataObject) => {
    const Imagedata = new FormData();
    Imagedata.append("image", DataObject.image);
    Imagedata.append("id", DataObject.id);

    fetch(`${url}/page/updateimage`, {
      method: "POST",
      body: Imagedata,
    })
      .then((res) => res.json())
      .then((data) => {
        console.log(data);
        if (data.message === "Success") {
          UpdateData();
        }
      });
  };

  const handleCancel = () => {
    setTextModalVisible(false);
    setImageModal(false);
  };

  const ShowTextModal = (id) => {
    setTextModalVisible(true);
    setUpdateId(id);
  };

  const showImageModal = (id) => {
    setImageModal(true);
    setUpdateId(id);
  };

  const TextHandle = () => {
    if (HeadingUpdate === "") {
      message.error("Fill the Field");
    } else {
      UpdateText({
        text: HeadingUpdate,
        id: UpdateId,
      });
      setTextModalVisible(false);
      setHeadingUpdate("");
    }
  };

  const OnImageHandle = () => {
    if (ImageUpdate === null) {
      message.error("Insert Image");
    } else {
      UpdateImage({
        image: ImageUpdate,
        id: UpdateId,
      });
      setImageModal(false);
    }
  };

  const OnEnterPress = (event) => {
    const a = HeadingUpdate;
    console.log(a);
    if (event.key === "Enter") {
      console.log("Enter Clicked");
      a.concat("\n");
      setHeadingUpdate(a);
    } else {
      console.log(event.key);
    }
  };

  return (
    <Layout>
      {StorageData && (
        <Header
          UpdateText={UpdateText}
          UpdateImage={UpdateImage}
          GetData={{
            imgId: StorageData.section1image1._id,
            headingId: StorageData.section1heading1._id
          }}
          Image={StorageData.section1image1.image}
        />
      )}

      {StorageData && (
        <div className="Storage-Cards">
          <div className="Card">
            {/* <div className='Image-div'>
              <i onClick={() => showImageModal(StorageData.section2image1._id)} className="far fa-edit Edit-btn"></i>
              <img
                src={`${url}/api/getFile${StorageData.section2image1.image}`}
                alt="Img"
                draggable="false"
              />
            </div> */}
            <h3>{StorageData.section2heading1.content}
              <i onClick={() => ShowTextModal(StorageData.section2heading1._id)} className="far fa-edit Edit-btn"></i>
            </h3>
            <div className="Storage-list">
              <p> {StorageData.section2paragraph1.content}</p>
              <i onClick={() => ShowTextModal(StorageData.section2paragraph1._id)} className="far fa-edit Edit-btn"></i>
            </div>
          </div>
          <div className="Card">
            {/* <div className='Image-div'>
              <i onClick={() => showImageModal(StorageData.section2image2._id)} className="far fa-edit Edit-btn"></i>
              <img
                src={`${url}/api/getFile${StorageData.section2image2.image}`}
                alt="Img"
                draggable="false"
              />
            </div> */}
            <h3>{StorageData.section2heading2.content}
              <i onClick={() => ShowTextModal(StorageData.section2heading2._id)} className="far fa-edit Edit-btn"></i>
            </h3>
            <div className="Storage-list">
              <p> {StorageData.section2paragraph3.content}</p>
              <i onClick={() => ShowTextModal(StorageData.section2paragraph3._id)} className="far fa-edit Edit-btn"></i>
            </div>
          </div>
          <div className="Card">
            {/* <div className='Image-div'>
              <i onClick={() => showImageModal(StorageData.section2image3._id)} className="far fa-edit Edit-btn"></i>
              <img
                src={`${url}/api/getFile${StorageData.section2image3.image}`}
                alt="Img"
                draggable="false"
              />
            </div> */}
            <h3>{StorageData.section2heading3.content}
              <i onClick={() => ShowTextModal(StorageData.section2heading3._id)} className="far fa-edit Edit-btn"></i>
            </h3>
            <div className="Storage-list">
              <i onClick={() => ShowTextModal(StorageData.section2paragraph5._id)} className="far fa-edit Edit-btn"></i>
              <p> {StorageData.section2paragraph5.content}</p>
            </div>
          </div>
        </div>
      )}

      {StorageData && (
        <div className="Storage-email-container">
          <h2> {StorageData.section3heading1.content}
            <i onClick={() => ShowTextModal(StorageData.section3heading1._id)} className="far fa-edit Edit-btn"></i>
          </h2>
          <div className="Storage-input-div">
            <img src={EmailImage} draggable="false" alt="Icon" />
            <input
              value={Email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Email Subscriber"
            />
            <button className="Button" onClick={OnEmailSubmit}>
              Submit
            </button>
          </div>
        </div>
      )}


      <Map />

      {
        StorageData && <GetQuoteForm UpdateImage={UpdateImage}
          imageID={StorageData.image._id} image={StorageData.image.image} />
      }

      {/* Update Text Modal */}
      <Modal width={400} style={{ top: '20%' }} title='Update Text' visible={TextModalVisible} onOk={TextHandle} onCancel={handleCancel} okText="Update" >
        <textarea onKeyPress={(e) => OnEnterPress(e)} value={HeadingUpdate} onChange={e => setHeadingUpdate(e.target.value)} className='Input' placeholder='Update Heading...' />
      </Modal>

      {/* Update Image Modal */}
      <Modal width={700} style={{ top: '5%' }} title='Update Image' visible={ImageModal} onOk={OnImageHandle} onCancel={handleCancel} okText="Update" >
        <DropzoneArea
          filesLimit={1}
          acceptedFiles={['image/*']}
          dropzoneText={"Update Product Images"}
          onChange={(files) => {
            console.log('Files:', files[0])
            setImageUpdate(files[0])
          }}
        />
      </Modal>

    </Layout>
  );
}

export default Storage;
